const activities = [
  {
    title: "Small Muscle Activity",
    items: [
      {
        type: "image",
        src: "/activities/small-muscle-1.jpg",
        alt: "Small Muscle Activity 1",
      },
      {
        type: "image",
        src: "/activities/small-muscle-2.jpg",
        alt: "Small Muscle Activity 2",
      },
      {
        type: "image",
        src: "/activities/small-muscle-3.jpg",
        alt: "Small Muscle Activity 3",
      },
      {
        type: "video",
        src: "/activities/small-muscle-4.mp4",
        alt: "Small Muscle Activity 4",
      },
    ],
  },

  {
    title: "Individual Activity",
    items: [
      {
        type: "image",
        src: "/activities/individual-1.jpg",
        alt: "Individual Activity 1",
      },
      {
        type: "image",
        src: "/activities/individual-2.jpg",
        alt: "Individual Activity 2",
      },
    ],
  },

  {
    title: "Large Muscle Activity",
    items: [
      {
        type: "video",
        src: "/activities/large-muscle-1.mp4",
        alt: "Large Muscle Activity 1",
      },
      {
        type: "video",
        src: "/activities/large-muscle-2.mp4",
        alt: "Large Muscle Activity 2",
      },
    ],
  },

  {
    title: "Group Activity",
    items: [
      {
        type: "video",
        src: "/activities/group-1.mp4",
        alt: "Group Activity 1",
      },
      {
        type: "video",
        src: "/activities/group-2.mp4",
        alt: "Group Activity 2",
      },
    ],
  },
];

export { activities };